import React, {useCallback, useEffect, useState} from 'react'
import _ from 'lodash'
import {Input, Spinner} from 'reactstrap'
import {useSelectedVariantContext} from '../../../context/SelectedVariantContext'
import {isSubsetAttributes} from '../../../context/SelectedVariantContext/helper'
import {usePreviewArtworks} from '../../../../../hooks/usePreviewArtworks'
import PreviewBackgroundImage from '../../../artwork-editor/preview/PreviewBackgroundImage'
import {actionUpdateSelectedPlacements} from '../../../context/SelectedVariantContext/action'
import useGTM, {buildProductPayload} from '../../../../../hooks/useGTM'

const ListPlacementsContainer = props => {
    const {fetchPreviews} = usePreviewArtworks()
    const {pushEvent} = useGTM()
    const domainCloudfront =  process.env.REACT_APP_CLOUDFRONT_URL || "https://d5xh8as6wnpix.cloudfront.net"
    const {
        state: {selectedAttribute, previewImages, selectedPlacements, reloadBgPreview, previewImages3D, has3DPreview, product, pickerVariants = []},
        dispatch,
    } = useSelectedVariantContext()
    const {mockups, variants} = product
    let mockupInfos = _.get(selectedAttribute?.mockup, 'meta.mockup_infos', [])
    const [previewSrc, setPreviewSrc] = useState([])
    const [loadingMockup, setLoadingMockup] = useState(true)
    const [loadingImages, setLoadingImages] = useState({})

    useEffect(() => {
        const initialLoading = {}
        mockupInfos.forEach((mockup) => {
            initialLoading[mockup.name] = true
        })
        setLoadingImages(initialLoading)
    }, [selectedAttribute?.mockup?._id])

    const handleSelectPlacement = (name, checked) => {
        pushEvent('select_mockup', {product: buildProductPayload(product, pickerVariants)})
        let _selectedPlacements = [...selectedPlacements]
        if (checked) {
            _selectedPlacements.push(name)
            dispatch(actionUpdateSelectedPlacements(_selectedPlacements))
        } else {
            dispatch(actionUpdateSelectedPlacements(_selectedPlacements.filter(place => place !== name)))
        }

    }

    const handleLoad = () => {
        setLoadingMockup(false);
    };

    const handleImageLoad = (mockupName) => {
        setLoadingImages(prev => ({
            ...prev,
            [mockupName]: false
        }))
    }

    const loadPreviewImages = useCallback(() => {
        if (!previewImages.length || !selectedAttribute) return []

        const selectedAttr = selectedAttribute.attributes.map((attr) => {
            return {type: attr.type, value: attr.value_code}
        })

        const images = previewImages
            .find((preview) => isSubsetAttributes(preview.attributes, selectedAttr))?.images || []
            .map((url) => `${url}?timestamp=${new Date().getTime()}`)
        setPreviewSrc(images.map(src => src.replace(/default_[^/]+/, "default").replace(/\/[0-9a-fA-F]{6}\//, "/FFFFFF/")))

    }, [previewImages, selectedAttribute, has3DPreview, previewImages3D])

    useEffect(() => {
        loadPreviewImages()
    }, [loadPreviewImages])

    useEffect(() => {
        fetchPreviews()
    }, [])

    return mockupInfos.length > 0 ? (
        <div className="ListPlacementsContainer">
            <h4 className="TitleVariantView">Placements</h4>
            <div className="PlacementsGrid d-flex">
                {
                    mockupInfos.map((mockup, index) => (
                        <div className="PlacementsItem" key={index}>
                            <div className="Image">
                                <img 
                                    src={`${domainCloudfront}/v2/preview/${selectedAttribute?.listSku?.[0]}/FFFFFF/default/front-name:${mockup.name}/regular.jpg`} 
                                    alt="" 
                                    onLoad={() => {
                                        handleLoad()
                                        handleImageLoad(mockup.name)
                                    }}
                                    style={{opacity: loadingImages[mockup.name] ? 0 : 1, transition: 'opacity 0.3s'}}
                                />
                                <div className="custom-control custom-checkbox">
                                    <Input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="selectAll"
                                        checked={selectedPlacements.includes(mockup.name)}
                                        onChange={(e) => handleSelectPlacement(mockup.name, e.target.checked)}
                                    />
                                </div>
                                {(loadingMockup || loadingImages[mockup.name]) && (
                                    <div className='ImageFirstLoading loadingBackground text-center'>
                                        <Spinner style={{color: '#007bff'}} />
                                    </div>
                                )}
                            </div>
                            <label>{mockup.name || ''}</label>
                        </div>
                    ))
                }
            </div>
        </div>
    ) : null
}

export default ListPlacementsContainer;